module.exports = __webpack_public_path__ + "img/logo_05.a40a4f56.png";